<template>
    <div>
        <NavigationReceiver currentQuestion="15"></NavigationReceiver>
        <section class="pt-5">
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-3">
                        <div class="alert alert-warning d-flex mb-2" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Kijk niet langer dan een week terug en vul dan de vragen zo goed mogelijk in.</span>
                        </div>
                        <div class="alert alert-warning d-flex mb-5" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Activiteiten die u wél als zwaar ervaart en die niet in de lijst staan, kunt u aan het eind toevoegen.</span>
                        </div>
                    </div>
                    <div class="col-xl-6 px-5">
                        <div class="row justify-content-center mb-4">
                            <div class="col-xl-3 col-4">
                                <img src="/img/questions/vraag14.png" class="img-fluid">
                            </div>
                        </div>
                        <h2 class="mb-4 text-center">{{ QuestionRepository.getQuestionValueById(15.1) }}</h2>
                        <div class="row justify-content-center">
                            <div class="col-lg-12 col-12">
                                <RadioField :error="error" :options="[{
                                        value: 'ja',
                                        title: 'Ja'
                                    }, {
                                        value: 'nee',
                                        title: 'Nee'
                                    }]" id="15.1"></RadioField>
                                <transition name="fade-in-up">
                                    <div v-if="showFields()">
                                        <TextareaField :placeholder="QuestionRepository.getQuestionValueById(15.2)" id="15.2" :title="QuestionRepository.getQuestionValueById(15.2)"></TextareaField>
                                        <span class="sub">{{ QuestionRepository.getQuestionValueById(15.3) }}</span>
                                        <NumberField id="15.3" placeholder="... minuten per keer" title="... minuten per keer"></NumberField>
                                        <span class="sub">{{ QuestionRepository.getQuestionValueById(15.4) }}</span>
                                        <NumberField id="14.4" placeholder="... minuten per dienst" title="... minuten per dienst"></NumberField>
                                    </div>
                                </transition>
                                <div class="text-center">
                                    <button @click="nextStep($event)" class="btn btn-primary mb-3">Volgende vraag</button>
                                    <br>
                                    <button class="btn-previous-question" @click="previousStep($event)">Vorige vraag</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NavigationReceiver from "../../../defaults/Navigation-receiver";
import RadioField from "../../../includes/RadioField";
import TextareaField from "../../../includes/TextareaField";
import SelectField from "../../../includes/SelectField";
import NumberField from "../../../includes/NumberField";
import defaultData from "./defaultData";
import RecipientService from "../../../../services/RecipientService";
import defaultMethods from "./defaultMethods";

export default {
    name:       'StepFifteen',
    components: { NumberField, SelectField, TextareaField, RadioField, NavigationReceiver },
    data() {
        return {
            ... defaultData,
            showFieldsOn:     '15.1',
            nextStepSlug:     'stap-16',
            previousStepSlug: 'stap-14',
            error:            false
        }
    },
    beforeRouteEnter(to, from, next) {
        RecipientService.getPrerequisites(to, from, next, true);
    },
    methods: {
        ... defaultMethods
    }
}
</script>
